/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/user.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const UserRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        Login: null,
        T: null,
        Password: null,
        Status: null,
    };

    const getPassword = () => {
        if (
            oldRecord.hasOwnProperty('Password') &&
            oldRecord.Password !== null &&
            oldRecord.Password !== newRecord.Password
        )
            return 'Password Changed';
        if (!oldRecord.Password && newRecord.Password) return 'Password Set';
        return null;
    };

    const refactoredNewRecord = {
        ...newRecord,
        Password: getPassword(),
        T: null,
        Status: null,
    };

    const enums: any = {
        // Status: AuditEnumValues.UserStatus,
        SystemAdminLevel: AuditEnumValues.AdminLevel,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { UserRecordChangeGrid };
